import { render, staticRenderFns } from "./sponsors.vue?vue&type=template&id=502819cc&scoped=true"
import script from "./sponsors.vue?vue&type=script&lang=js"
export * from "./sponsors.vue?vue&type=script&lang=js"
import style0 from "./sponsors.vue?vue&type=style&index=0&id=502819cc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "502819cc",
  null
  
)

export default component.exports